/**
 * Every team this app is ever deployed as (one per white-label domain), with the real
 * numeric id that domain's DOMAIN_CONFIG.teamId resolves to. Single source of truth for
 * code that needs to reference a specific known team regardless of which one is currently
 * deployed (e.g. a team-level route exclusion) — edit here to add/rename/renumber a team.
 * Names match ThemeService's teamThemeMap keys (theme.service.ts) exactly.
 */
export interface KnownTeam {
  teamId: number;
  teamCode: string;
  teamName: string;
}

export const WASHINGTON_TEAM: KnownTeam = { teamId: 5047, teamCode: '', teamName: 'washington' };
export const OLIMPIC_TEAM: KnownTeam = { teamId: 32, teamCode: '', teamName: 'olimpic' };
export const LONDON_CITY_TEAM: KnownTeam = { teamId: 170, teamCode: '', teamName: 'londoncity' };

export const KNOWN_TEAMS: readonly KnownTeam[] = [WASHINGTON_TEAM, OLIMPIC_TEAM, LONDON_CITY_TEAM];
